module.exports = __webpack_public_path__ + "img/icon_cowchinresting_colour.06680a0f.svg";